/**
 * Asynchronously loads the component for CampusIndustryConnectViewAllJobs
 */

import { lazyLoad } from "utils/loadable";

export const CampusIndustryConnectViewAllJobs = lazyLoad(
  () => import("./index"),
  (module) => module.CampusIndustryConnectViewAllJobs
);
